import { lazy } from 'react';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));
// sample page routing
const User = Loadable(lazy(() => import('views/user')));
const Product = Loadable(lazy(() => import('views/product')));
const Plan = Loadable(lazy(() => import('views/plan')));
const Dealer = Loadable(lazy(() => import('views/dealer')));
const Reseller = Loadable(lazy(() => import('views/reseller')));
const DistributorReseller = Loadable(lazy(() => import('views/reseller/distributor')));
const Customer = Loadable(lazy(() => import('views/customer')));
const ResellerCustomer = Loadable(lazy(() => import('views/customer/reseller')));
const DistributorCustomer = Loadable(lazy(() => import('views/customer/distributor')));
const DistributorSubscription = Loadable(lazy(() => import('views/subscription/distributor')));
const ResellerSubscription = Loadable(lazy(() => import('views/subscription/reseller')));
const CustomerSubscription = Loadable(lazy(() => import('views/subscription/customer')));
const Subscription = Loadable(lazy(() => import('views/subscription')));
const Order = Loadable(lazy(() => import('views/order')));
const Profile = Loadable(lazy(() => import("views/account-profile")));
const Log = Loadable(lazy(() => import("views/log")));

const Association = Loadable(lazy(() => import('views/association')));
const Consultant = Loadable(lazy(() => import('views/consultant')));
const IndustryArea = Loadable(lazy(() => import('views/industry-area')));
const Prospect = Loadable(lazy(() => import('views/prospect')));
const API = Loadable(lazy(() => import('views/api')));
const Hsn = Loadable(lazy(() => import('views/hsn')));

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    // {
    //   path: '/',
    //   element: <DashboardDefault />
    // },

    { path: 'dashboard', element: <DashboardDefault /> },
    // {
    //   path: 'dashboard',
    //   children: [
    //     {
    //       path: 'default',
    //       element: <DashboardDefault />
    //     }
    //   ]
    // },
    {
      path: 'utils',
      children: [
        { path: 'util-typography', element: <UtilsTypography /> }
      ]
    },
    {
      path: 'utils',
      children: [
        { path: 'util-color', element: <UtilsColor /> }
      ]
    },
    {
      path: 'utils',
      children: [
        { path: 'util-shadow', element: <UtilsShadow /> }
      ]
    },
    {
      path: 'icons',
      children: [
        { path: 'tabler-icons', element: <UtilsTablerIcons /> }
      ]
    },
    {
      path: 'icons',
      children: [
        { path: 'material-icons', element: <UtilsMaterialIcons /> }
      ]
    },
    { path: 'user', element: <User /> },
    { path: 'distributor', element: <Dealer /> },
    { path: 'reseller', element: <Reseller /> },
    { path: 'distributor-reseller', element: <DistributorReseller /> },
    { path: 'customer', element: <Customer /> },
    { path: 'reseller-customer', element: <ResellerCustomer /> },
    { path: 'distributor-customer', element: <DistributorCustomer /> },
    { path: 'plan', element: <Plan /> },
    { path: 'product', element: <Product /> },
    { path: 'subscription', element: <Subscription /> },
    { path: 'distributor-subscription', element: <DistributorSubscription /> },
    { path: 'reseller-subscription', element: <ResellerSubscription /> },
    { path: 'customer-subscription', element: <CustomerSubscription /> },
    { path: 'order', element: <Order /> },
    { path: 'account-profile', element: <Profile /> },
    { path: 'activity-log', element: <Log /> },
    { path: 'association', element: <Association /> },
    { path: 'consultant', element: <Consultant /> },
    { path: 'industrial-area', element: <IndustryArea /> },
    { path: 'prospect', element: <Prospect /> },
    { path: 'api', element: <API /> },
    { path: 'hsn', element: <Hsn /> },
  ]
};

export default MainRoutes;